import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { ShieldCheck, FileText, Scale } from "lucide-react";

const LINKS = [
  { to: "/confidentialite", label: "Confidentialité (Loi 25)", icon: ShieldCheck, testid: "legal-link-privacy" },
  { to: "/conditions", label: "Conditions d'utilisation", icon: FileText, testid: "legal-link-terms" },
  { to: "/mentions-legales", label: "Mentions légales", icon: Scale, testid: "legal-link-notice" },
];

export function LegalLayout({ title, subtitle, updated, current, description, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [current]);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="legal-page">
      <SEO title={title} description={description || subtitle} path={current} />
      <Header />
      <main className="pt-28 pb-24">
        <div className="mx-auto max-w-6xl px-5 lg:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-mono uppercase tracking-[0.3em] text-[#EAB308]">Informations légales</span>
            <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold text-white tracking-tight">{title}</h1>
            {subtitle && <p className="mt-4 text-white/60 text-lg leading-relaxed">{subtitle}</p>}
            {updated && <p className="mt-3 text-xs text-white/40 font-mono">Dernière mise à jour : {updated}</p>}
          </div>

          <div className="mt-12 grid lg:grid-cols-[220px_1fr] gap-10">
            <aside className="lg:sticky lg:top-24 self-start">
              <nav className="flex flex-col gap-1.5">
                {LINKS.map((l) => (
                  <Link
                    key={l.to}
                    to={l.to}
                    data-testid={l.testid}
                    className={`flex items-center gap-2.5 rounded-md px-3 py-2.5 text-sm transition-colors ${
                      current === l.to
                        ? "bg-[#EAB308]/10 border border-[#EAB308]/30 text-[#EAB308] font-medium"
                        : "text-white/60 hover:text-white hover:bg-white/5 border border-transparent"
                    }`}
                  >
                    <l.icon className="w-4 h-4" />
                    {l.label}
                  </Link>
                ))}
              </nav>
            </aside>

            <article className="max-w-3xl pg-legal space-y-8 text-white/70 leading-relaxed">
              {children}
            </article>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export function LegalSection({ id, title, children }) {
  return (
    <section id={id} className="scroll-mt-28">
      <h2 className="text-xl sm:text-2xl font-bold text-white">{title}</h2>
      <div className="mt-3 space-y-3">{children}</div>
    </section>
  );
}
